import React from "react";
import { Reveal } from "../shared/Reveal";

export default function SolarChart() {
  return (
    <section id="solar-waste" className="solarchart">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">THE HIDDEN PROBLEM</Reveal>
        <Reveal className="scht" tag="h2">Solar Can't Fix the Energy You're <span className="g">Already Wasting.</span></Reveal>
        <Reveal className="sclead" tag="p">
          Up to <b>30%</b> of your energy bill is pure waste — lost to hidden inefficiency before it powers anything.
          And this waste exists <b>whether you have Solar PV installed or not.</b>
        </Reveal>

        <Reveal className="wastebar-wrap" tag="div" data-testid="waste-visual">
          <div className="wastebar-title">Your current annual energy spend</div>
          <div className="wastebar" role="img" aria-label="Up to 30% of your energy spend is wasted; around 70% is energy your business genuinely uses">
            <div className="wb-seg wb-waste">
              <span className="wb-pc">up to 30%</span>
              <span className="wb-lb">WASTED — hidden inefficiency</span>
            </div>
            <div className="wb-seg wb-used">
              <span className="wb-pc">~70%</span>
              <span className="wb-lb">Energy your business genuinely uses</span>
            </div>
          </div>
          <div className="wastekey" data-testid="waste-key">
            <span className="wk-strong">Whether you have Solar PV installed or not</span> — up to 30% of your
            energy bill is waste. Solar and batteries only work on the energy you actually need; they can&rsquo;t
            remove this waste. <span className="g">We find and eliminate it first.</span>
          </div>
        </Reveal>

        <Reveal className="scquote" tag="blockquote">
          "No amount of Solar PV or Battery Storage will eliminate the energy your building is <span className="g">already wasting</span>. Building Intelligence comes first."
        </Reveal>
      </div>
    </section>
  );
}
